module.exports = __webpack_public_path__ + "static/covid-5599ed23253080a5cb928b1de0c94bcb.png";